module.exports = __webpack_public_path__ + "static/img/基站使用说明书.9e2fb0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/基站使用说明书.png
// module id = B+Zl
// module chunks = 0